/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page, auditAction, auditableType, source, dateFrom, dateTo, actor } = {}) {
    // Keeping filters in query params makes the listing shareable and keeps pagination compatible with the backend endpoint.
    const params = {};
    if (page) {
      params.page = page;
    }
    if (auditAction) {
      params.audit_action = auditAction;
    }
    if (auditableType) {
      params.auditable_type = auditableType;
    }
    if (source) {
      params.source = source;
    }
    if (dateFrom) {
      params.date_from = dateFrom;
    }
    if (dateTo) {
      params.date_to = dateTo;
    }
    if (actor) {
      params.actor = actor;
    }

    return axios.get(this.url, { params });
  }
}

export default new AuditLogs();
